import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners
} from '@angular/core';

import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { AuthInterceptor } from 'core/interceptors/http.interceptor';

import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LANG_CODES } from './shared/enums/common.enum';

import { MatDialogModule } from '@angular/material/dialog';
import { provideToastr } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging'; import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([AuthInterceptor])
    ),
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'M/d/yyyy' }
    },

    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      progressBar: true,
      preventDuplicates: false,
      newestOnTop: true,
      autoDismiss: true
    }),
    importProvidersFrom(
      MatDialogModule,
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({
          prefix: '/assets/i18n/',
          suffix: `.json?v=${environment.buildVersion}`
        }),
        fallbackLang: LANG_CODES.ENGLISH
      })
    ),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideMessaging(() => getMessaging())
  ]
};
